"use client"
import BaseImage from "@/app/(site)/_components/Atoms/BaseImage"
import { ImageType } from "@/types"
import React from "react"
interface FirstImageProps {
    firstCardImage: ImageType
    isAboveTheFold: boolean
    cardAlignment: boolean
}

const FirstImage: React.FC<FirstImageProps> = ({
    firstCardImage,
    isAboveTheFold,
    cardAlignment
}) => {
    return (
        <div
            className={`relative block w-full ${
                cardAlignment ? "aspect-3/2 md:aspect-11/6" : "aspect-3/2"
            } `}
        >
            <BaseImage
                src={firstCardImage.asset._ref}
                mimeType={firstCardImage?.asset?.mimeType || ""}
                alt={firstCardImage.alt ?? ""}
                priority={isAboveTheFold}
                fill
                loading={isAboveTheFold ? "eager" : "lazy"}
                className="object-cover"
                sizes="(max-width: 968px) 90vw, (max-width: 1280px) 75vw, 75vw"
            />
        </div>
    )
}

export default FirstImage
